import { useEmpi } from 'datashop-incare-commons/helpers/routing';
import { get, intersection } from 'lodash';
import { IUser } from 'patientCommons/interfaces/entities/user';

export const getUserId = (): string | undefined => {
  return useEmpi()!;
};

// Return user object from local storage
export const getLoggedInUser = () => {
  return JSON.parse(localStorage.getItem('auth.user.active') || '{}');
};

// Checks if the user is authorised with the `permissions`
export const isUserAuthorised = (permissions: string[]) => {
  // Check if the array `a` contains all the elements of array `b`
  const contains = (a: string[], b: string[]): boolean => b.length === 0 || intersection(a, b).length === b.length;

  const userObject = getLoggedInUser();

  return contains(get(userObject, 'permissions', []), permissions);
};

export const isInactiveUser = (status: IUser['status']) => {
  return status === 'Disabled' || status === 'Deleted';
};
